export default "__VITE_ASSET__d8790d86__"